// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_container__nsVY6 {
    -webkit-user-select: none;
            user-select: none;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 100px;
    height: 100%;
    background-color: #1D2F52;
    box-shadow: #1A2026 0 0 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.sidebar_section__bgqyJ {
    border-radius: 6px;
    margin: 10% 0;
    background-color: #24437e;
    width: 50px;
    height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".container {\n    user-select: none;\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 100px;\n    height: 100%;\n    background-color: #1D2F52;\n    box-shadow: #1A2026 0 0 4px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.section {\n    border-radius: 6px;\n    margin: 10% 0;\n    background-color: #24437e;\n    width: 50px;\n    height: 50px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sidebar_container__nsVY6`,
	"section": `sidebar_section__bgqyJ`
};
export default ___CSS_LOADER_EXPORT___;
